<template>
    <main-page>
        <h1>hello world</h1>
    </main-page>
</template>

<script>
import MainPage from '@/components/main-page'
export default {
    components:{MainPage}
}
</script>